<template>
	<view>
		<form>
			<view class="cu-form-group margin-top">
				<view class="title">单号</view>
				<input v-model="billNo" placeholder="扫码 / 输入" name="input" autocomplete="off">
			</view>
			<view class="cu-form-group margin-top">
				<view class="title">托盘码</view>
				<input v-model="code" placeholder="扫码 / 输入" name="input">
			</view>
		</form>
		<view class="margin-top">
			<uni-table border stripe emptyText="暂无更多数据">
				<uni-tr>
					<uni-th>物料编码</uni-th>
					<uni-th>生产单号</uni-th>
					<uni-th>数量</uni-th>
					<uni-th>物料名称</uni-th>
				</uni-tr>
				<uni-tr>
					<uni-td>1121</uni-td>
					<uni-td>1121</uni-td>
					<uni-td>1121</uni-td>
					<uni-td>1121</uni-td>
				</uni-tr>
			</uni-table>
			
		</view>
		<view>
			<button class="cu-btn bg-yellow pda-btn">组托</button>
			<button class="cu-btn bg-grey pda-btn" @click="reset">重置</button>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				billNo:'',
				code:'',
			}
		},
		methods: {
				reset:function() {
					let that =this;
					that.billNo = '';
					that.code = '';
				},
				
		},
		onShow() {
			// const query = uni.createSelectorQuery()
			// console.log(prototype.placeholder)
		}
	}
</script>

<style>
	
</style>
